import styled from 'styled-components';

export const NoInvoicesContainer = styled.div`
  margin: 16px 0;
`;
